import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    Input,
} from "@angular/core";

import { Asset } from "@hermes/api-model-asset";
import { ProductStoryDeprecated } from "@hermes/api-model-editorial";
import { LOCALE } from "@hermes/app-core";
import { Locale } from "@hermes/locale";
import {
    getGridTitle,
    getVariantLabelPart,
} from "@hermes/states/grid-filters-state";
import { generateLocalizedHref } from "@hermes/utils/helpers";
import { RouterService } from "@hermes/utils-generic/services/router";

@Component({
    selector: "h-product-card",
    templateUrl: "./product-card.component.html",
    styleUrls: ["./product-card.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardComponent {
    public productAsset!: Asset;

    public urlRedirect!: string;

    public productVariant!: string;

    public title!: string;

    private prProduct!: ProductStoryDeprecated;

    constructor(
        @Inject(LOCALE) private locale: Locale,
        private routerService: RouterService,
    ) {}

    public get product(): ProductStoryDeprecated {
        return this.prProduct;
    }

    @Input()
    public set product(product: ProductStoryDeprecated) {
        this.prProduct = product;
        this.title = getGridTitle(product);
        this.productVariant = getVariantLabelPart(product);
        this.productAsset = product.assets[0];
        this.urlRedirect = generateLocalizedHref(product.url, this.locale);
    }

    public productSPARedirect(event: MouseEvent): void {
        event.preventDefault();
        this.routerService.spaRedirect(this.urlRedirect);
    }
}
